import React from 'react';
import { WA_NUMBER } from '../data/products';
export function Footer() {
  return <footer className="bg-[#080808] border-t border-[#1a1a1a] py-10 px-5 text-center" data-id="element-143">
      <div className="max-w-[1100px] mx-auto flex flex-col items-center" data-id="element-144">
        <div className="mb-2.5" data-id="element-145">
          <img src="https://cdn.magicpatterns.com/uploads/o9QuWRFj9QDHop4MmMKe7L/Logo_-_Editado.png" alt="AlphaFit" className="h-12 object-contain mx-auto" onError={e => {
          e.currentTarget.style.display = 'none';
          e.currentTarget.nextElementSibling?.classList.remove('hidden');
        }} data-id="element-146" />
          <div className="hidden text-[1.6rem] font-black text-alphaGold tracking-[3px] uppercase" data-id="element-147">
            Alpha<span className="text-white" data-id="element-148">Fit</span>
          </div>
        </div>

        <p className="text-[#555] text-[0.85rem] leading-[1.7] mb-5" data-id="element-149">
          Suplementos en Montevideo, Uruguay.
          <br data-id="element-150" />
          Malvín, Montevideo · Lunes a Sábados 10:00–18:00 · Domingos cerrado
        </p>

        <div className="flex gap-6 justify-center flex-wrap mb-5" data-id="element-151">
          <a href="#productos" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-152">
            Productos
          </a>
          <a href="#nosotros" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-153">
            Nosotros
          </a>
          <a href="#faq" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-154">
            FAQ
          </a>
          <a href="#envios" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-155">
            Envíos
          </a>
          <a href={`https://wa.me/${WA_NUMBER}`} target="_blank" rel="noopener noreferrer" className="text-[#666] no-underline text-[0.85rem] transition-colors duration-300 hover:text-alphaGold" data-id="element-156">
            WhatsApp
          </a>
        </div>

        <p className="text-[#333] text-[0.8rem]" data-id="element-157">
          © {new Date().getFullYear()} AlphaFit · Todos los derechos reservados
        </p>
      </div>
    </footer>;
}